import { ChangeDetectionStrategy, Component, inject, input, OnDestroy, OnInit, viewChild } from '@angular/core';
import { ToolbarPortalService } from '../toolbar-portal.service';
import { CdkPortal } from '@angular/cdk/portal';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'oo-nav-back',
  templateUrl: './nav-back.component.html',
  styleUrls: ['./nav-back.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CdkPortal, RouterLink, MatIcon],
})
export class NavBackComponent implements OnInit, OnDestroy {
  readonly url = input.required<string>();
  readonly backElement = viewChild.required(CdkPortal);
  private readonly toolbarPortalService = inject(ToolbarPortalService);

  ngOnInit(): void {
    this.toolbarPortalService.setTitlePortal(this.backElement());
  }

  ngOnDestroy(): void {
    this.toolbarPortalService.unsetTitlePortal();
  }
}
